import ParkOutlinedIcon from '@mui/icons-material/ParkOutlined';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type {SxProps} from '@mui/system';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import LabelChip from '@/components/common/LabelChip';
import Title from '@/components/common/Title';
import type {InventoryPlot} from '@/domain/entities/InventoryPlot';

//TYPES
type Props = {
  inventoryPlot: InventoryPlot;
};

const InventoryPlotTotalVolumes: FC<Props> = ({inventoryPlot}) => {
  const {t} = useTranslation();

  const {volumeUsc, volumeIfn} = inventoryPlot;

  return (
    <>
      <Stack>
        <Title size="h6" label={t('inventoryPlots.totalStemVolumes')} />
      </Stack>
      <Stack direction="column" spacing={2}>
        <LabelChip value={t('inventoryPlots.volumeUsc')} icon={ParkOutlinedIcon} width={LABEL_WIDTH}>
          <Typography variant="body2" sx={styles.value}>
            {formatVolume(volumeUsc)}
          </Typography>
        </LabelChip>
        <LabelChip value={t('inventoryPlots.volumeIfn')} icon={ParkOutlinedIcon} width={LABEL_WIDTH}>
          <Typography variant="body2" sx={styles.value}>
            {formatVolume(volumeIfn)}
          </Typography>
        </LabelChip>
      </Stack>
    </>
  );
};
export default InventoryPlotTotalVolumes;

const LABEL_WIDTH = '160px';

const formatVolume = (volume?: number): string =>
  volume === undefined || volume === null
    ? '-'
    : volume.toLocaleString('es-ES', {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      });

const styles: Record<string, SxProps> = {
  value: {
    pt: 1,
    fontWeight: 700,
  },
};
